(function ($)
{
    jQuery.fn.editable = function (option)
    {
        var setting =
        {
            _csrf: {},
            url: '.',
            paramName: "param",
            resultName: "result",
            keyboardOKCancel: true,
            confirmFlag: false,
            reload: false
        };
        if (option)
        {$.extend(setting, option);}

        if (!setting._csrf.header)
        {
            setting._csrf.header = $("meta[name='_csrf_header']").attr("content");
        }
        if (!setting._csrf.parameter)
        {
            setting._csrf.parameter = $("meta[name='_csrf_parameter']").attr("content");
        }
        if (!setting._csrf.token)
        {
            setting._csrf.token = $("meta[name='_csrf']").attr("content");
        }

        var $editedValue;
        var exitCode = false;

        var makeEditable = function (e)
        {
            var $paramName = ($(this).data("name")) ? $(this).data("name") : setting.paramName;
            var $resultName = ($(this).data("result")) ? $(this).data("result") : setting.resultName;
            var $aDiv = e.data.aDiv;

            $editedValue = $(this).html().trim();
//            e.preventDefault();
//            e.stopPropagation();


            var $input = $('<input/>').val($editedValue.replace(/(&nbsp;)*/g, ""));
            $input.height($aDiv.height());
            $input.attr('id', $aDiv.attr('id'));
            $input.attr("size", $editedValue.trim().length + 5);
            $input.css('font-family', $aDiv.css('font-family'));
            $input.css('font-size', $aDiv.css('font-size'));

            $input.blur(function () {
                if (setting.confirmFlag)
                {
                    exitCode = exitCode && confirm('Вы уверены?');
                }
                if (exitCode && $editedValue != $(this).val())
                {
                    var data = {};
                    data[setting._csrf.parameter] = setting._csrf.token;
                    data[$paramName] = $(this).val();
                    $.ajax({
                        type: "POST",
                        url: ($aDiv.data("url")) ? $aDiv.data("url") : setting.url,
                        dataType: 'json',
                        data: data,
                        async: false,
                        error: function (data)
                        {
                            alert('Ошибка: ' + data.responseText);
                        },
                        success: function (data)
                        {
                            $editedValue = data[$resultName];
                            if (setting.reload)
                            {
                                document.location.reload();
                            }
                        }
                    });
                }
                $aDiv.html($editedValue);
                $aDiv.bind('click', {aDiv: $aDiv}, makeEditable);
                exitCode = false;
            });


            if (setting.keyboardOKCancel)
            {
                $input.keydown(function (eventObject)
                {
                    if (eventObject.which === 13 || eventObject.which === 27)
                    {
                        eventObject.preventDefault();
                        return false;
                    }
                    else
                    {
                        return true;
                    }
                });
                $input.keyup(function (eventObject)
                {
                    if (eventObject.which === 27)
                    {
                        exitCode = false;
                        $(this).blur();
                    }
                    else if (eventObject.which === 13)
                    {
                        exitCode = true;
                        $(this).blur();
                    }
                });
            }
            if (setting.buttonOK)
            {
//                an OK button with handling will be here
            }

            $aDiv.text('');
            $aDiv.append($input);
            $aDiv.unbind('click');
            $input.focus().select();

            return false;
        };

        var doIt = function ()
        {
            $(this).bind('click', {aDiv: $(this)}, makeEditable);
            $(this).addClass('ewf_editable');
        };
        return this.each(doIt);
    };
})(jQuery);